import { ReactElement, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import ModalConfirmation from "@components/ModalConfirmation";
import Table from "@components/Table";
import Loader from "@components/Loader";
import Title from "@components/Title";
import CreateBtn from "@components/CreateButton";
import useDeleteItem from "@hooks/Shared/useDeleteItem";
import useListColumns from "@hooks/Security/Projects/useListColumns";
import deleteProject from "@services/Core/ProjectManager/deleteProject";
import { EUiStates } from "@constants/enum";
import useListItems from "@hooks/Shared/useListItems";
import getProjects from "@services/Core/ProjectManager/getProjects";
import listProjectsMapper from "@mappers/Security/Projects/ListProject.mapper";

const ListProjects = (): ReactElement => {
  const { t } = useTranslation(["core"]);
  const [isDeletingItem, setIsDeletingItem] = useState(false);
  const { isLoading, basicData, tableItems } = useListItems(
    isDeletingItem,
    getProjects,
    listProjectsMapper,
    true
  );
  const { isModalOpen, isDeleting, handleDelete, handleIsModalOpen } =
    useDeleteItem(basicData);
  const COLUMNS = useListColumns();

  useEffect(() => {
    setIsDeletingItem(isDeleting);
  }, [isDeleting]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <ModalConfirmation
        icon="trash"
        title={`${t("core:common.projects")} | ${t(
          "core:common.delete_confirm"
        )}`}
        body={`${t("core:notifications.delete_message")} "${
          basicData?.text
        }" ?`}
        handleConfirm={() => {
          handleDelete(deleteProject);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.DANGER}
      />

      <Title />
      <CreateBtn />
      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListProjects;
